export default __webpack_public_path__ + "static/media/3-3-2.0036bfa9.jpg";